/**
 * 이용약관 본문 — docs/input/indipia_이용약관및운영정책 방식 기획(화면구성예시).html의
 * #view-terms 콘텐츠(제1장~제9장·부칙)와 #policy-src의 운영정책 1~8을 그대로 포팅.
 * 원본은 운영정책을 모달로 띄웠지만, 정적 페이지에서는 같은 문서 하단에 절로 붙이고
 * "운영정책 N" 링크는 그 절의 앵커(#policy-pN)로 바로 이동하도록 바꿨다.
 */
export const termsContent = `
<div class="doc-head">
  <h1>인디피아 서비스 이용약관</h1>
  <p class="meta"><b>V1.0</b> · 시행일: 2026년 9월 1일 · 주식회사 와이앤씨스마트앱스 (이하 '회사')</p>
</div>

<div class="card">
  <h2 style="font-size:14px;font-weight:700;color:var(--sub);margin-bottom:10px">회사 정보 (전자상거래법 제10조 표시사항 — 서비스 초기화면 게시)</h2>
  <table>
    <tbody>
      <tr><th>상호</th><td>주식회사 와이앤씨스마트앱스</td></tr>
      <tr><th>대표자</th><td>윤석중</td></tr>
      <tr><th>사업장 주소</th><td>서울특별시 강남구 봉은사로20길 41 와이앤씨빌딩</td></tr>
      <tr><th>전화 / 이메일</th><td>1588-9592 / indipia@yncsmart.com</td></tr>
      <tr><th>사업자등록번호</th><td>144-81-05037</td></tr>
      <tr><th>통신판매업 신고번호</th><td>2026-서울강남-00722</td></tr>
      <tr><th>개인정보 보호책임자</th><td>이향호</td></tr>
    </tbody>
  </table>
</div>

<div class="card toc">
  <h2>목차</h2>
  <ol>
    <li><a href="#ch1">제1장 총칙 (제1조~제5조)</a></li>
    <li><a href="#ch2">제2장 회원가입 및 이용계약 (제6조~제8조)</a></li>
    <li><a href="#ch3">제3장 서비스 (제9조~제13조)</a></li>
    <li><a href="#ch4">제4장 요금 및 결제 (제14조~제16조)</a></li>
    <li><a href="#ch5">제5장 데이터 및 지식재산권 (제17조~제21조)</a></li>
    <li><a href="#ch6">제6장 회원의 의무 및 이용제한 (제22조~제25조)</a></li>
    <li><a href="#ch7">제7장 회사의 의무 및 개인정보 (제26조~제27조)</a></li>
    <li><a href="#ch8">제8장 손해배상 및 면책 (제28조~제30조)</a></li>
    <li><a href="#ch9">제9장 기타 (제31조~제34조)</a></li>
    <li><a href="#addendum">부칙</a></li>
  </ol>
</div>

<section class="chapter" id="ch1">
  <h2>제1장 총칙</h2>
  <article>
    <h3>제1조 (목적)</h3>
    <p>본 약관은 주식회사 와이앤씨스마트앱스(이하 '회사')가 운영하는 인디피아 SaaS 플랫폼(이하 '서비스')의 이용 조건 및 절차, 회사와 회원 간의 권리·의무를 정함을 목적으로 합니다.</p>
  </article>
  <article>
    <h3>제2조 (정의)</h3>
    <ol class="hang">
      <li>① '서비스'란 회사가 인테리어 사업자에게 제공하는 사진정리·견적·실측·일정·공사현황 등 업무 자동화 SaaS 및 이에 부수하는 부가서비스를 말합니다.</li>
      <li>② '회원'이란 본 약관에 동의하고 가입한 자로, 제7조에 따라 인테리어사업자 회원과 일반 회원으로 구분됩니다.</li>
      <li>③ 'AI 에이전트'란 서비스에서 제공하는 모듈형 업무 도구를 말합니다.</li>
      <li>④ '회원 데이터'란 회원이 서비스를 통해 생성·저장한 데이터를 말합니다.</li>
      <li>⑤ '부가서비스'란 자재중계·시공중계·광고 등 별도의 개별서비스 약관이 적용되는 서비스를 말합니다.</li>
      <li>⑥ '운영정책'이란 회사가 본 약관의 위임에 따라 세부 사항을 정하여 서비스 내에 게시하는 정책을 말합니다.</li>
    </ol>
  </article>
  <article>
    <h3>제3조 (약관의 효력 및 변경)</h3>
    <ol class="hang">
      <li>① 본 약관은 서비스 화면에 게시함으로써 효력이 발생합니다. 회사는 본 약관과 함께 상호·대표자·사업장 주소·연락처·사업자등록번호·통신판매업 신고번호 등 사업자 정보를 서비스 초기화면에 게시합니다.</li>
      <li>② 회사는 관계 법령에 위배되지 않는 범위에서 약관을 개정할 수 있으며, 일반적인 변경은 적용일 7일 전부터 서비스 내에 공지합니다.</li>
      <li>③ 회원에게 불리하거나 중대한 변경은 적용일 30일 전부터 공지함과 동시에 이메일 등으로 개별 통지하며, 회원이 동의하지 않을 경우 이용계약을 해지할 수 있음을 함께 고지합니다. 회원이 적용일까지 거부 의사를 표시하지 않으면 동의한 것으로 봅니다.</li>
    </ol>
  </article>
  <article>
    <h3>제4조 (관계 법령 및 운영정책)</h3>
    <ol class="hang">
      <li>① 본 약관에서 정하지 않은 사항은 전자상거래법, 약관규제법, 개인정보 보호법, 정보통신망법, 인공지능 기본법 등 관계 법령 및 운영정책에 따릅니다.</li>
      <li>② 회사는 본 약관에서 위임한 세부 사항과 서비스 운영에 필요한 사항을 운영정책으로 정하여 서비스 내에 게시할 수 있습니다.</li>
      <li>③ 운영정책은 본 약관의 일부를 구성하며, 약관과 운영정책이 상충하는 경우 약관이 우선합니다.</li>
      <li>④ 회사는 운영정책의 제·개정 시 서비스 내에 공지합니다. 다만 회원에게 불리한 핵심 사항(요금 인상, 회원 권리의 제한, 데이터 활용 범위의 확대 등)은 운영정책이 아닌 제3조의 약관 변경 절차에 따릅니다.</li>
    </ol>
  </article>
  <article>
    <h3>제5조 (통지)</h3>
    <ol class="hang">
      <li>① 회사는 서비스 내 공지, 이메일, 앱 푸시, 알림톡, 문자 등으로 회원에게 통지하며, 전자적 통지는 도달한 때 효력이 발생합니다.</li>
      <li>② 약관 변경·결제·장애 등 서비스에 필수적인 통지는 회원이 수신을 거부할 수 없습니다. 마케팅·프로모션 통지는 회원의 선택적 동의에 따르며, 야간(오후 9시~오전 8시) 광고성 정보 전송 시 별도 동의를 받습니다.</li>
    </ol>
  </article>
</section>

<section class="chapter" id="ch2">
  <h2>제2장 회원가입 및 이용계약</h2>
  <article>
    <h3>제6조 (회원가입)</h3>
    <ol class="hang">
      <li>① 회원가입은 아이디 가입 또는 SNS 간편가입(구글·네이버·카카오)으로 진행되며, 국세청 API를 통한 사업자 진위 확인을 거칩니다. 비정상(폐업 등) 사업자는 가입이 제한될 수 있습니다.</li>
      <li>② 계정은 대표계정(마스터)과 직원계정(부계정)으로 구분되며, 직원계정은 대표계정의 승인을 받아 이용할 수 있습니다.</li>
      <li>③ 가입 시 회원은 이용약관에 동의하며, 서비스 제공(계약의 이행)에 필요한 개인정보는 본 약관 및 개인정보 처리방침에 따라 수집·이용됩니다(별도의 동의를 요하지 않습니다). 마케팅 정보 수신 등 선택 사항은 별도로 동의를 받으며, AI 학습 데이터 활용 등 일부 선택 동의는 가입 이후 설정 화면 등에서 받을 수 있습니다. 비밀번호는 암호화하여 저장합니다.</li>
    </ol>
  </article>
  <article>
    <h3>제7조 (회원 자격 및 유형)</h3>
    <ol class="hang">
      <li>① 회원은 인테리어사업자 회원(사업자등록증을 보유한 인테리어 사업체 대표 또는 소속 직원)과 일반 회원(향후 서비스 확장 시 적용되는 개인)으로 구분됩니다.</li>
      <li>② 인테리어사업자 회원은 가입 시 취급 공종을 선택하며, 선택 공종에 따라 적합한 에이전트·요금제가 추천됩니다. 공종은 설정에서 변경할 수 있습니다.</li>
      <li>③ 회원 자격 및 사업 정보에 변경이 있는 경우 회원은 지체 없이 정보를 수정하여야 합니다.</li>
    </ol>
  </article>
  <article>
    <h3>제8조 (이용계약의 성립)</h3>
    <ol class="hang">
      <li>① 이용계약은 회원이 본 약관에 동의하고 가입을 완료한 시점에 성립합니다. 계정 상태는 정상·승인대기·정지·탈퇴 등으로 관리됩니다.</li>
      <li>② 회사는 타인 명의 도용, 허위 정보 기재, 사업자등록 말소 등의 경우 가입을 거절하거나 사후 해지할 수 있습니다.</li>
      <li>③ 계정 보안(로그인 실패 잠금 등) 및 장기 미접속 계정의 휴면 전환에 관한 세부 기준은 회사가 정하는 <a class="plink" href="#policy-p4">운영정책 4. 계정 보안·휴면 정책</a>에 따릅니다.</li>
    </ol>
  </article>
</section>

<section class="chapter" id="ch3">
  <h2>제3장 서비스</h2>
  <article>
    <h3>제9조 (서비스의 구성·변경 및 부가서비스)</h3>
    <ol class="hang">
      <li>① 서비스는 AI 에이전트 마켓플레이스, 내 스튜디오(개인화된 업무 공간) 및 각종 에이전트(사진정리·공사스케줄·공사현황·물량산출·캘린더·견적작성 등)로 구성됩니다. 세부 기능은 구독 패키지에 따라 다를 수 있습니다.</li>
      <li>② 회사는 사업상 필요에 따라 서비스의 전부 또는 일부를 추가·변경·중단할 수 있습니다. 기존 서비스 범위 내의 기능·에이전트 추가는 서비스 내 공지로 제공하며, 회원에게 불리하지 않은 경우 별도 동의 없이 적용됩니다.</li>
      <li>③ 회원에게 불리하거나 중대한 변경·중단의 경우 회사는 30일 전에 공지하며, 회원은 이에 동의하지 않을 경우 이용계약을 해지할 수 있습니다.</li>
      <li>④ 회사는 일부 기능을 베타로 제공할 수 있으며, 베타 기능은 '있는 그대로(AS-IS)' 무보증으로 제공되고 변경·중단될 수 있습니다.</li>
      <li>⑤ 자재중계·시공중계·광고 등 부가서비스에는 별도의 개별서비스 약관이 적용되며, 회원이 해당 부가서비스를 처음 이용하는 시점에 동의 절차를 거칩니다. 회사가 통신판매중개자 등 새로운 지위를 갖게 되는 경우 관계 법령에 따른 고지·표시 의무를 이행합니다.</li>
    </ol>
  </article>
  <article>
    <h3>제10조 (AI 서비스의 정확도·투명성 및 면책)</h3>
    <ol class="hang">
      <li>① 본 서비스는 AI에 기반하여 운용되며, 도면 변환·자동 견적·추천·음성 분석 등에 생성형 AI가 사용됩니다. 회사는 인공지능 기본법에 따라 이러한 사실을 회원에게 고지합니다.</li>
      <li>② 회사는 생성형 AI가 생성·보조한 결과물에 대해 그 사실을 인식 가능한 방법으로 표시합니다.</li>
      <li>③ AI 기반 결과는 참고 목적으로 제공되며 회사는 그 정확성을 보증하지 않습니다. 회원은 현장 확인과 전문적 판단을 통해 최종 의사결정을 합니다.</li>
      <li>④ AI 서비스의 오류로 인한 손해에 대한 회사의 책임은 제29조(면책)에 따릅니다.</li>
    </ol>
  </article>
  <article>
    <h3>제11조 (도면 DB 및 데이터 공유)</h3>
    <ol class="hang">
      <li>① 회원이 직접 생성·보정한 도면의 저작권은 해당 회원에게 있습니다. 회사는 회원 동의 하에 회원 생성 도면을 비식별화하여 공유 도면 DB 구축 및 AI 정확도 향상에 활용할 수 있으며, 회원은 자신의 도면이 공유 DB에 포함되는 것을 거부할 수 있습니다.</li>
      <li>② 공유 도면은 참고용이며, 실제 시공 시에는 현장 실측으로 확인하여야 합니다. 도면 DB 기여 인센티브 등 세부 사항은 <a class="plink" href="#policy-p6">운영정책 6. 도면·자재가격 DB 이용 정책</a>에 따릅니다.</li>
    </ol>
  </article>
  <article>
    <h3>제12조 (전자계약 및 전자서명)</h3>
    <ol class="hang">
      <li>① 회사는 회원과 그 고객 간의 시공 관련 계약 체결을 지원하기 위해 전자문서·전자서명 기능을 제공할 수 있으며, 전자문서 및 전자거래 기본법·전자서명법에 따라 그 효력이 인정됩니다.</li>
      <li>② 회사는 회원과 고객 간 계약의 당사자가 아니며, 회원은 전자서명 이용 시 고객으로부터 필요한 동의를 적법하게 확보하여야 합니다.</li>
    </ol>
  </article>
  <article>
    <h3>제13조 (제3자 서비스 연동)</h3>
    <ol class="hang">
      <li>① 서비스는 결제(PG), 인증(SNS·국세청 API), 지도·위치, 알림(알림톡·푸시) 등 제3자 서비스와 연동됩니다.</li>
      <li>② 제3자 서비스의 장애·변경·중단으로 인한 서비스 제한에 대해 회사는 책임을 지지 않습니다. 다만 회사의 고의 또는 중대한 과실이 있는 경우는 제외합니다.</li>
    </ol>
  </article>
</section>

<section class="chapter" id="ch4">
  <h2>제4장 요금 및 결제</h2>
  <article>
    <h3>제14조 (구독 요금)</h3>
    <ol class="hang">
      <li>① 서비스는 모듈형 에이전트를 선택·구독하는 요금 체계를 적용하며, 구체적인 요금 구성·금액은 서비스 내 별도 공지 및 운영정책으로 정합니다.</li>
      <li>② 구독 요금은 월 단위로 청구·자동 갱신되며, 갱신 전 사전 안내를 발송합니다. 부가가치세는 별도입니다.</li>
      <li>③ 회사는 요금제·정책을 변경할 수 있으며, 변경 시 사전에 공지합니다. 회원에게 불리한 변경은 제3조의 절차에 따릅니다.</li>
    </ol>
  </article>
  <article>
    <h3>제15조 (무료 체험 및 프로모션)</h3>
    <ol class="hang">
      <li>① 회사는 신규 회원에게 무료 체험을 제공할 수 있습니다. 무료 체험 종료 시 유료 구독으로 자동 전환되지 않으며, 유료 전환은 회원의 명시적 선택에 의합니다. 회사는 전환 전 사전 안내를 발송합니다.</li>
      <li>② 프로모션·추천 혜택의 세부 내용은 <a class="plink" href="#policy-p8">운영정책 8. 무료체험·프로모션 정책</a>으로 정하며, 회사의 사정에 따라 변경·종료될 수 있습니다.</li>
    </ol>
  </article>
  <article>
    <h3>제16조 (결제 및 환불)</h3>
    <ol class="hang">
      <li>① 결제는 신용카드·계좌이체·간편결제 등으로 할 수 있으며, 구독 요금은 PG사 연동을 통해 자동 결제됩니다.</li>
      <li>② 구독 중도 해지 시 환불 기준·방법은 회사의 <a class="plink" href="#policy-p1">환불정책(운영정책 1)</a>에 따릅니다. 회사는 합리적인 기준에 따라 잔여 기간을 정산하며 부당한 위약금을 부과하지 않습니다.</li>
      <li>③ 대표계정 탈퇴 시 유료 구독이 있는 경우 구독 해지 및 정산이 선행됩니다.</li>
    </ol>
  </article>
</section>

<section class="chapter" id="ch5">
  <h2>제5장 데이터 및 지식재산권</h2>
  <article>
    <h3>제17조 (회원 데이터의 소유 및 활용 기준)</h3>
    <ol class="hang">
      <li>① 회원이 서비스를 통해 생성·저장한 회원 데이터(견적·계약·도면·실측, 고객 정보 및 거래 내역, 단가·마진, 거래처 정보 등)의 소유권은 해당 회원에게 있습니다.</li>
      <li>② 회원 데이터의 활용 기준은 유형별로 다음과 같이 차등 적용됩니다.
        <ol class="num">
          <li>회원의 영업 데이터(단가·마진·견적 등): 서비스 제공 목적으로만 처리하며, 개별 단가·마진은 다른 회원에게 식별 가능한 형태로 노출하거나 회사의 영업 목적으로 이용하지 않습니다.</li>
          <li>고객 개인정보 및 거래처 정보: 서비스 제공 범위 내에서만 처리하며 제18조 및 관련 법령에 따릅니다.</li>
          <li>도면 등 공유형 데이터: 제11조에 따라 비식별화 후 활용될 수 있습니다.</li>
          <li>비식별·통계 데이터: 제19조에 따라 활용될 수 있습니다.</li>
        </ol>
      </li>
      <li>③ 회사는 서비스 제공 목적 외에 회원 데이터를 임의로 이용·제공하지 않으며, 회원은 데이터를 내보낼 수 있습니다. 보관 기간·내보내기 형식·탈퇴 시 처리 등 세부 사항은 <a class="plink" href="#policy-p3">운영정책 3. 데이터 보관·파기 및 다운로드 정책</a>에 따릅니다. 회사는 암호화·접근통제 등 보호 조치를 취합니다.</li>
    </ol>
  </article>
  <article>
    <h3>제18조 (고객 개인정보의 처리위탁)</h3>
    <ol class="hang">
      <li>① 회원이 입력·저장하는 고객(소비자)의 개인정보에 대하여 회원은 개인정보처리자, 회사는 회원의 위탁을 받아 처리하는 수탁자의 지위를 가집니다.</li>
      <li>② 회원은 고객의 개인정보를 입력하기 전 정보주체로부터 적법한 동의·고지를 확보할 책임이 있으며, 회사는 위탁 범위 내에서만 이를 처리합니다(개인정보처리방침 적용).</li>
    </ol>
  </article>
  <article>
    <h3>제19조 (플랫폼 데이터 활용·맞춤추천 및 AI 학습)</h3>
    <ol class="hang">
      <li>① 회사는 서비스 개선·통계·AI 모델 학습을 위하여 개인 및 개별 사업 정보가 식별되지 않도록 비식별·통계 처리한 데이터를 활용할 수 있으며, 회원은 비식별 데이터의 활용을 거부(사후거부)할 수 있습니다.</li>
      <li>② 개인을 식별할 수 있는 정보 또는 회원의 식별 가능한 영업 데이터를 AI 학습 등에 활용하는 경우, 회사는 회원의 별도 동의(사전동의)를 받으며, 이 동의는 가입 절차가 아닌 설정 화면 등에서 받을 수 있습니다.</li>
      <li>③ 개별 회원의 단가·마진·고객·거래처 정보는 식별 가능한 형태로 활용되지 않으며, 회사는 거래처 정보를 자재중계·시공중계 등 공급망 구축에 회원의 명시적 동의 없이 전용하지 않습니다.</li>
      <li>④ 회사는 회원의 이용·검색 등 행태정보를 분석하여 해당 회원에게 자재·견적·콘텐츠 등을 맞춤 추천할 수 있으며, 회원은 이를 거부할 수 있습니다(개인정보처리방침 적용).</li>
      <li>⑤ 데이터 활용의 세부 범위·기간 및 사전동의/사후거부 방법은 <a class="plink" href="#policy-p5">AI 데이터 활용 정책(운영정책 5)</a>에 따릅니다.</li>
    </ol>
  </article>
  <article>
    <h3>제20조 (지식재산권 및 회원 콘텐츠)</h3>
    <ol class="hang">
      <li>① 서비스의 소프트웨어·AI 모델·디자인·콘텐츠 등 지식재산권은 회사에 귀속됩니다. 회원은 서비스를 통해 생성한 견적서·계약서 등을 자신의 영업에 자유롭게 사용할 수 있으나, 회사의 AI 모델·소스코드 등을 역설계·복제·배포할 수 없습니다.</li>
      <li>② 회원이 등록한 콘텐츠(시공 사진·포트폴리오·후기 등)의 저작권은 회원에게 있으며, 회원은 회사가 서비스 운영·홍보 목적으로 이를 이용할 수 있는 비독점적·무상의 이용허락을 부여합니다. 회사는 타인의 권리를 침해하는 콘텐츠를 삭제하거나 비공개 처리할 수 있습니다.</li>
    </ol>
  </article>
  <article>
    <h3>제21조 (콘텐츠 임시조치 및 권리침해 게시중단)</h3>
    <ol class="hang">
      <li>① 회사는 회원이 게시한 콘텐츠가 타인의 권리 침해, 명예훼손, 음란·폭력, 개인정보 포함, 허위·기만 광고, 관계 법령·약관 위반에 해당한다고 판단되는 경우 임시조치(삭제·차단·블라인드)할 수 있으며 그 사유를 회원에게 통지합니다.</li>
      <li>② 권리를 침해받은 자는 관련 법령에 따라 침해 사실을 소명하여 게시중단을 요청할 수 있고, 회사는 지체 없이 필요한 조치를 한 후 권리자와 게시 회원에게 통지합니다. 통지를 받은 회원은 이의를 제기할 수 있으며, 이의가 정당한 경우 회사는 조치를 해제합니다. <span class="rel">관련: <a class="plink" href="#policy-p7">운영정책 7. 커뮤니티·콘텐츠 운영 가이드라인</a></span></li>
    </ol>
  </article>
</section>

<section class="chapter" id="ch6">
  <h2>제6장 회원의 의무 및 이용제한</h2>
  <article>
    <h3>제22조 (회원의 의무)</h3>
    <ol class="hang">
      <li>① 회원은 타인 정보 도용, 부정확한 견적에 의한 소비자 기만, 서비스 운영 방해, 계정 공유·양도 등의 행위를 하여서는 안 됩니다.</li>
      <li>② 회원은 회사의 사전 동의 없이 봇·크롤러·스크래퍼·리버스 엔지니어링 등을 이용하여 자재 단가·가격 DB·도면 DB 등을 무단 수집·복제·재배포하거나 서버에 과도한 부하를 일으켜서는 안 됩니다. 위반 시 회사는 이용을 정지하고 위약금을 포함한 손해배상을 청구할 수 있습니다(<a class="plink" href="#policy-p6">운영정책 6.4 무단수집 제재</a>).</li>
      <li>③ 회원은 관계 법령·약관·운영정책을 준수하고 본인의 계정 정보를 안전하게 관리할 책임이 있습니다.</li>
    </ol>
  </article>
  <article>
    <h3>제23조 (서비스 이용 제한)</h3>
    <ol class="hang">
      <li>① 회사는 회원이 다음에 해당하는 경우 경고·일시정지·영구정지 등 단계적으로 이용을 제한하거나 계약을 해지할 수 있습니다: 제22조의 의무 위반, 구독료 2회 이상 연속 미납, 사업자등록 말소, 어뷰징(매크로·다수 계정 등), 무단 접근·크롤링, 지식재산권·명예 침해.</li>
      <li>② 긴급한 경우(해킹·불법행위 등)에는 사전 통지 없이 즉시 제한하고 사후 통지합니다.</li>
      <li>③ 회사는 이용을 제한하는 경우 사유·유형·기간 및 이의신청 절차를 통지하며, 회원의 이의신청이 정당하다고 판단되는 경우 즉시 이용을 재개합니다.</li>
    </ol>
  </article>
  <article>
    <h3>제24조 (직원관리 및 소속관리)</h3>
    <ol class="hang">
      <li>① 대표계정은 직원계정의 승인·반려·소속 해제를 할 수 있고, 직원계정은 소속을 해제하거나 다른 업체에 소속을 신청할 수 있습니다(대표계정 승인 필요). 소속 변경 시 관련 당사자에게 알림이 발송됩니다.</li>
    </ol>
  </article>
  <article>
    <h3>제25조 (회원탈퇴)</h3>
    <ol class="hang">
      <li>① 회원은 언제든지 탈퇴를 요청할 수 있습니다. 직원계정 탈퇴 시 소속이 해제되고, 대표계정 탈퇴 시 소속 직원·미납 요금·진행 중 발주가 없어야 하며 유료 구독은 해지·정산이 선행됩니다.</li>
      <li>② 탈퇴 시 데이터 보관·삭제 처리는 제17조 및 <a class="plink" href="#policy-p3">운영정책 3. 데이터 보관·파기 및 다운로드 정책</a>에 따릅니다.</li>
    </ol>
  </article>
</section>

<section class="chapter" id="ch7">
  <h2>제7장 회사의 의무 및 개인정보</h2>
  <article>
    <h3>제26조 (회사의 의무 및 서비스 수준)</h3>
    <ol class="hang">
      <li>① 회사는 안정적인 서비스 제공을 위해 노력하며, 장애 발생 시 지체 없이 복구하고 그 현황을 공지합니다. 정기 점검 등으로 서비스를 일시 중단하는 경우 사전 공지합니다.</li>
      <li>② 회사는 카카오톡·전화 등을 통해 회원의 문의·불만을 접수·처리합니다.</li>
      <li>③ 서비스 가용률 목표 및 미달 시 보상 등 서비스 수준(SLA)에 관한 사항은 <a class="plink" href="#policy-p2">SLA 운영정책(운영정책 2)</a>에 따릅니다.</li>
    </ol>
  </article>
  <article>
    <h3>제27조 (개인정보 및 위치정보의 보호)</h3>
    <ol class="hang">
      <li>① 회사는 개인정보 보호법 등 관련 법령에 따라 회원의 개인정보를 보호하며, 수집·이용·제공·위탁·국외이전·파기 등 구체적 사항은 별도의 <a href="/privacy">개인정보처리방침</a>에 따릅니다.</li>
      <li>② 회사는 지도·매칭 등 서비스 제공을 위해 위치정보를 이용할 수 있습니다. 단말기 GPS 등으로 개인위치정보를 실시간 수집·처리하는 경우에는 위치정보의 보호 및 이용 등에 관한 법률에 따라 동의를 받고 별도의 위치기반서비스 정책을 적용합니다.</li>
    </ol>
  </article>
</section>

<section class="chapter" id="ch8">
  <h2>제8장 손해배상 및 면책</h2>
  <article>
    <h3>제28조 (손해배상)</h3>
    <ol class="hang">
      <li>① 회사의 귀책사유로 회원에게 직접적 손해가 발생한 경우 회사는 실제 발생한 직접손해를 배상하며, 그 책임 한도는 해당 회원의 최근 12개월 구독료 합산액으로 합니다.</li>
      <li>② 회사는 간접·결과적·특별손해 및 일실이익에 대하여 책임을 지지 않습니다.</li>
      <li>③ 제1항의 한도 및 제2항의 면책은 회사의 고의 또는 중대한 과실로 인한 손해, 개인정보 유출로 인한 손해에는 적용되지 않습니다.</li>
    </ol>
  </article>
  <article>
    <h3>제29조 (면책)</h3>
    <ol class="hang">
      <li>① 회사는 천재지변 등 불가항력, 회원의 귀책사유, 제3자 서비스의 장애로 인한 서비스 장애에 대하여 책임을 지지 않습니다.</li>
      <li>② AI 추천·견적 및 자재 단가·가격 정보는 참고용 추정치로서 현장 조건에 따라 실제와 다를 수 있으며, 그 결과에 따른 회원의 사업 손실에 대해 회사는 책임을 지지 않습니다. 가격 정보에는 기준일이 표시됩니다.</li>
      <li>③ 회사는 회원에게 업무 도구·플랫폼을 제공할 뿐, 회원과 그 고객 간의 상담·견적·시공 거래의 당사자가 아니며 어느 일방을 대리하지 않습니다. 향후 부가서비스 도입으로 회사가 통신판매중개자의 지위를 갖게 되는 경우 그 책임 범위는 제9조 및 해당 개별서비스 약관에 따릅니다.</li>
      <li>④ 본 조의 면책은 회사의 고의 또는 중대한 과실이 있는 경우에는 적용되지 않습니다.</li>
    </ol>
  </article>
  <article>
    <h3>제30조 (회원의 배상 책임)</h3>
    <ol class="hang">
      <li>① 회원이 본 약관을 위반하거나 제3자의 권리를 침해하여 회사 또는 제3자에게 손해를 발생시킨 경우 회원은 그 손해를 배상할 책임이 있습니다. 회원은 인디피아를 통해 고객과 체결한 시공 계약에 대하여 전적으로 책임을 집니다.</li>
    </ol>
  </article>
</section>

<section class="chapter" id="ch9">
  <h2>제9장 기타</h2>
  <article>
    <h3>제31조 (분쟁 해결)</h3>
    <ol class="hang">
      <li>① 본 약관은 대한민국 법률을 준거법으로 하며, 분쟁이 발생한 경우 회사와 회원은 상호 협의로 해결하도록 노력합니다.</li>
      <li>② 협의가 이루어지지 않는 경우 전자거래분쟁조정위원회 등 분쟁조정기관의 조정을 거칠 수 있으며, 조정이 성립되지 않으면 회사 본점 소재지 관할 법원을 제1심 관할 법원으로 합니다.</li>
    </ol>
  </article>
  <article>
    <h3>제32조 (가분성)</h3>
    <p>본 약관의 일부 조항이 무효이거나 집행 불가능하더라도 나머지 조항의 효력에는 영향을 미치지 않습니다.</p>
  </article>
  <article>
    <h3>제33조 (권리·의무의 양도 금지)</h3>
    <p>회원은 회사의 사전 서면 동의 없이 본 약관상 지위 또는 권리·의무를 제3자에게 양도·이전하거나 담보로 제공할 수 없습니다.</p>
  </article>
  <article>
    <h3>제34조 (계약 해지 후 효력 존속)</h3>
    <p>이용계약이 해지된 후에도 제17조(회원 데이터)·제18조(고객 개인정보 위탁)·제19조(데이터 활용)·제20조(지식재산권 및 콘텐츠)·제27조(개인정보·위치정보)·제28조(손해배상)·제29조(면책)·제30조(회원의 배상 책임)·제31조(분쟁 해결)·제32조(가분성)는 그 성질에 따라 유효하게 존속합니다. 회원은 해지 후에도 회사의 영업비밀·AI 모델·자재가격 DB 등에 대한 비밀유지 의무를 부담합니다.</p>
  </article>
</section>

<section class="chapter" id="addendum">
  <h2>부칙</h2>
  <article>
    <ol class="hang" style="margin-top:14px">
      <li>① (시행일) 본 약관은 2026년 9월 1일부터 시행합니다.</li>
      <li>② (경과 조치) 본 약관 시행 이전에 가입한 회원에게도 본 약관이 적용됩니다. 다만 종전 약관에 의해 이미 발생한 권리·의무에는 영향을 미치지 않습니다.</li>
    </ol>
  </article>
</section>

<div class="card" style="background:var(--primary-soft)">
  <h2 style="font-size:14px;font-weight:700;color:var(--sub);margin-bottom:10px">운영정책의 효력 및 변경 원칙</h2>
  <ul>
    <li>본 운영정책은 인디피아 서비스 이용약관에 위임한 세부 사항을 정한 것으로, 약관의 일부를 구성합니다(약관 제4조). 약관과 상충 시 약관이 우선합니다.</li>
    <li>회사는 본 정책을 변경할 수 있으며, 변경 시 서비스 내에 공지합니다. 다만 회원에게 불리한 핵심 사항(요금 인상, 회원 권리의 제한, 데이터 활용 범위 확대 등)은 약관 변경 절차(제3조: 30일 전 개별통지 등)에 따릅니다.</li>
    <li>아래 수치(환불 기간·가용률·보관기간 등)는 현행 운영값이며, 위 절차에 따라 조정될 수 있습니다. 개인정보 처리방침은 별도 문서를 따릅니다.</li>
  </ul>
</div>

<section class="policy" id="policy-p1">
  <h2>운영정책 1. 환불정책</h2>
  <p class="link-ref">연결: <a class="plink" href="#ch4">약관 제16조</a></p>
  <h3>1.1 적용 범위</h3>
  <p>인디피아 유료 구독 회원에게 적용됩니다.</p>
  <h3>1.2 환불 기준</h3>
  <ul>
    <li>결제일로부터 7일 이내 해지: 전액 환불(서비스를 실질적으로 사용하지 않은 경우).</li>
    <li>7일 경과 후 해지: 잔여 이용 기간을 일할 계산하여 환불하며, 부당한 위약금을 부과하지 않습니다.</li>
    <li>무료 체험 기간 중 해지: 결제가 발생하지 않으므로 환불 대상이 없습니다.</li>
  </ul>
  <h3>1.3 구독 유형별 산정</h3>
  <ul>
    <li>월 구독: 사용 일수를 일할 차감한 잔액을 환불합니다.</li>
    <li>연 구독(제공 시): 사용 개월을 차감하고 잔여분을 환불하며, 연 할인 적용분은 정산될 수 있습니다.</li>
    <li>단품 에이전트: 개별 구독 기준으로 위 기준을 동일하게 적용합니다.</li>
  </ul>
  <h3>1.4 처리 기간 및 방법</h3>
  <p>원래 결제 수단으로 환불하며, 환불 승인 후 영업일 기준 5일 이내 처리합니다(카드사·PG 사정에 따라 추가 소요될 수 있습니다).</p>
  <h3>1.5 환불 예외·차감</h3>
  <ul>
    <li>프로모션·추천·무료로 제공된 금액 또는 기간은 환불 대상이 아닙니다.</li>
    <li>회원의 약관 위반으로 회사가 이용계약을 해지한 경우 환불이 제한될 수 있습니다.</li>
    <li>이미 발행된 세금계산서는 환불 시 수정 발행합니다.</li>
  </ul>
  <h3>1.6 신청 방법</h3>
  <p>서비스 내 구독 관리 메뉴 또는 고객센터를 통해 신청합니다.</p>
</section>

<section class="policy" id="policy-p2">
  <h2>운영정책 2. 서비스 수준(SLA) 정책</h2>
  <p class="link-ref">연결: <a class="plink" href="#ch7">약관 제26조</a></p>
  <h3>2.1 가용률 목표(월간 기준)</h3>
  <ul>
    <li>MVP 기간: 99.0%</li>
    <li>정식 서비스 전환 후: 99.5%</li>
    <li>가용률 = (총 운영시간 − 장애시간) ÷ 총 운영시간 × 100</li>
  </ul>
  <h3>2.2 산정 제외</h3>
  <p>사전 공지된 정기 점검, 회원 귀책, 제3자 서비스 장애, 천재지변 등 불가항력으로 인한 중단은 가용률 산정에서 제외합니다.</p>
  <h3>2.3 장애 대응</h3>
  <p>장애 인지 즉시 복구에 착수하며 24시간 이내 복구를 목표로 합니다. 중대 장애 발생 시 서비스 내 공지와 함께 원인·복구 현황을 안내합니다.</p>
  <h3>2.4 미달 시 보상</h3>
  <ul>
    <li>정식: 월 구독료를 기준으로 일할 산정한 서비스 크레딧을 제공합니다.</li>
    <li>보상은 회원의 신청 또는 회사의 확인에 따라 적용하며, 누적 보상은 해당 월 구독료 범위를 한도로 합니다.</li>
  </ul>
  <h3>2.5 정기 점검</h3>
  <p>가급적 야간·저부하 시간대에 시행하며 사전에 공지합니다.</p>
</section>

<section class="policy" id="policy-p3">
  <h2>운영정책 3. 데이터 보관·파기 및 다운로드 정책</h2>
  <p class="link-ref">연결: <a class="plink" href="#ch5">약관 제17조</a>·<a class="plink" href="#ch6">제25조</a> / <a href="/privacy">개인정보처리방침</a>과 일치</p>
  <h3>3.1 보관</h3>
  <p>회원 데이터는 서비스 이용 기간 동안 보관하며, 회원 탈퇴 시 30일간 보관한 후 복구 불가능하게 파기합니다.</p>
  <h3>3.2 데이터 다운로드</h3>
  <ul>
    <li>형식: 견적·계약서(PDF·CSV), 도면(원본 이미지 + 편집 데이터 PNG/SVG), 고객 목록·거래 내역(CSV), 현장 사진(원본 이미지).</li>
    <li>제외 대상: 타 회원 도면, AI 모델, 벤더 가격 원본.</li>
    <li>방법: 서비스 내 다운로드 기능. 회원 탈퇴 전 필요한 데이터는 회원이 직접 다운로드합니다.</li>
  </ul>
  <h3>3.3 법령상 보존</h3>
  <p>전자상거래법(계약·결제 기록 5년, 소비자 분쟁 3년 등) 및 국세 관련 5년 등 법정 보존 의무가 있는 데이터는 해당 기간 보관 후 파기합니다(개인정보처리방침과 동일).</p>
  <h3>3.4 파기 방법</h3>
  <p>전자적 파일은 복구·재생이 불가능한 방법으로 영구 삭제하고, 출력물은 분쇄하거나 소각합니다.</p>
</section>

<section class="policy" id="policy-p4">
  <h2>운영정책 4. 계정 보안·휴면 정책</h2>
  <p class="link-ref">연결: <a class="plink" href="#ch2">약관 제8조</a></p>
  <h3>4.1 비밀번호</h3>
  <p>최소 8자리(문자·숫자·특수문자 사용 가능)이며 암호화(Bcrypt)하여 저장합니다.</p>
  <h3>4.2 로그인 보호</h3>
  <p>비밀번호를 10회 연속 잘못 입력하면 해당 계정을 1시간 동안 잠그며, 잠금 해제 시간을 안내합니다.</p>
  <h3>4.3 휴면 전환</h3>
  <p>회원이 12개월 동안 서비스에 접속하지 않는 경우, 사전 안내(이메일 등) 후 해당 계정을 휴면 상태로 전환합니다. 휴면 계정은 로그인 및 서비스 이용이 제한됩니다.</p>
  <h3>4.4 재활성화</h3>
  <p>휴면 계정은 본인 인증 절차를 거쳐 재활성화할 수 있습니다.</p>
  <h3>4.5 참고</h3>
  <p>휴면 전환·분리보관은 법정 의무가 아닌 회사 정책으로 운영합니다(개인정보 유효기간제 폐지 반영).</p>
</section>

<section class="policy" id="policy-p5">
  <h2>운영정책 5. AI 데이터 활용·학습 정책</h2>
  <p class="link-ref">연결: <a class="plink" href="#ch5">약관 제19조</a> / <a href="/privacy">개인정보처리방침</a>과 연계</p>
  <h3>5.1 대상 데이터</h3>
  <p>비식별·통계 처리된 도면 데이터, 견적 패턴 데이터, 실측 보정 데이터에 한합니다.</p>
  <h3>5.2 처리 원칙</h3>
  <p>개인 및 개별 사업 정보(거래처·단가·마진 등)가 식별되지 않도록 비식별 처리합니다. 개별 회원의 단가·마진·고객·거래처 정보는 식별 가능한 형태로 활용하지 않으며, 거래처 정보를 자재중계·시공중계 등 공급망 구축에 회원의 명시적 동의 없이 전용하지 않습니다.</p>
  <h3>5.3 동의 구조</h3>
  <ul>
    <li>비식별·통계 데이터 활용: 옵트아웃 — 회원은 설정에서 활용을 거부할 수 있습니다.</li>
    <li>식별 가능 정보 또는 회원의 식별 가능한 영업 데이터 학습: 옵트인 — 별도 동의를 받습니다.</li>
    <li>거부 시 추천 정확도 향상 등 일부 기능이 제한될 수 있으나, 핵심 서비스 이용에는 제한이 없습니다.</li>
  </ul>
  <h3>5.4 보관기간</h3>
  <p>비식별 데이터는 활용 목적 달성에 필요한 기간(예: 비식별 후 3년) 동안 보관합니다.</p>
  <h3>5.5 맞춤형 추천</h3>
  <p>회원의 이용·검색 행태정보를 분석하여 자재·견적·콘텐츠 등을 맞춤 추천하며, 회원은 이를 거부할 수 있습니다(개인정보처리방침 적용).</p>
  <h3>5.6 안전조치</h3>
  <p>가명·비식별 정보를 재식별하지 않으며, 재식별 금지 및 안전성 확보 조치를 취합니다.</p>
</section>

<section class="policy" id="policy-p6">
  <h2>운영정책 6. 도면·자재가격 DB 이용 정책</h2>
  <p class="link-ref">연결: <a class="plink" href="#ch3">약관 제11조</a>·<a class="plink" href="#ch8">제29조</a></p>
  <h3>6.1 도면 DB</h3>
  <ul>
    <li>회원이 직접 생성·보정한 도면의 저작권은 회원에게 있으며, 회사는 회원 동의 하에 이를 비식별화하여 공유 도면 DB 구축 및 AI 학습에 활용합니다.</li>
    <li>동일 단지·평형의 표준 도면은 비식별 처리 후 다른 회원에게 공유될 수 있으며, 회원은 자신의 도면이 공유 DB에 포함되는 것을 거부(옵트아웃)할 수 있습니다.</li>
    <li>공유 도면은 참고용이며 실제 시공 시 현장 실측으로 확인하여야 합니다.</li>
  </ul>
  <h3>6.2 기여 인센티브</h3>
  <p>도면 DB 기여도가 높은 회원에게 구독료 할인 등 인센티브를 제공할 수 있으며, 세부 기준은 별도로 공지합니다.</p>
  <h3>6.3 자재 가격 DB</h3>
  <ul>
    <li>가격 정보는 참고용이며 기준일·유효기간이 표시되고, 견적서에는 기준일이 자동 삽입됩니다.</li>
    <li>벤더(KCC·LX하우시스 등) 제공 가격의 정확성은 보증하지 않으며, 최종 거래 가격은 회원과 거래처 간 협의에 따릅니다.</li>
  </ul>
  <h3>6.4 무단수집 제재</h3>
  <p>봇·크롤러·대량 조회·재배포 등 무단 수집을 금지하며, 위반 시 이용 정지 및 위약금을 포함한 손해배상을 청구할 수 있습니다(약관 제22조).</p>
</section>

<section class="policy" id="policy-p7">
  <h2>운영정책 7. 커뮤니티·콘텐츠 운영 가이드라인</h2>
  <p class="link-ref">연결: <a class="plink" href="#ch5">약관 제20조·제21조</a></p>
  <h3>7.1 적용 대상</h3>
  <p>회원이 게시하는 시공 사례·포트폴리오·후기 등 콘텐츠에 적용합니다.</p>
  <h3>7.2 권장 사항</h3>
  <p>실제 시공에 기반한 정확한 정보를 게시하고, 본인 저작물이거나 적법한 이용 권한을 보유한 콘텐츠만 등록합니다.</p>
  <h3>7.3 금지 콘텐츠</h3>
  <p>타인의 저작권·상표권 침해, 명예훼손·비방, 음란·폭력·차별 조장, 타인의 개인정보 포함, 허위·기만적 견적·광고, 매크로·도배 등 비정상 게시.</p>
  <h3>7.4 임시조치</h3>
  <p>위반이 의심되는 콘텐츠는 사전 통지 없이 삭제·차단·블라인드할 수 있으며, 그 사유를 게시 회원에게 통지합니다.</p>
  <h3>7.5 권리침해 신고·게시중단</h3>
  <p>권리를 침해받은 자는 침해 사실을 소명하여 게시중단을 요청할 수 있고, 회사는 지체 없이 필요한 조치를 한 후 권리자와 게시 회원에게 통지합니다. 게시 회원은 이의를 제기할 수 있습니다.</p>
  <h3>7.6 개인정보·프라이버시</h3>
  <p>시공 사진에 사람 또는 고객의 집 내부가 포함될 수 있으므로 주의하며, 외부 공유 시 사진의 위치 메타데이터(EXIF) 제거를 권장합니다.</p>
  <h3>7.7 콘텐츠 이용허락</h3>
  <p>콘텐츠 저작권은 회원에게 있으며, 회사는 서비스 운영·홍보 목적의 비독점적 이용허락을 부여받습니다(약관 제20조).</p>
</section>

<section class="policy" id="policy-p8">
  <h2>운영정책 8. 무료체험·프로모션 정책</h2>
  <p class="link-ref">연결: <a class="plink" href="#ch4">약관 제15조</a></p>
  <h3>8.1 무료 체험</h3>
  <ul>
    <li>신규 회원에게 무료 체험을 제공합니다(예: 첫 1개월 무료체험, 회사가 정하여 공지).</li>
    <li>무료 체험 종료 시 유료 구독으로 자동 전환되지 않으며, 유료 전환은 회원의 명시적 선택에 의합니다.</li>
    <li>전환 안내: 체험 종료 3일 전·1일 전·당일에 안내를 발송합니다.</li>
  </ul>
  <h3>8.2 프로모션</h3>
  <ul>
    <li>얼리버드(예: 초기 100개 업체 특별 할인) 및 추천인 혜택(예: 추천한 회원 1개월 연장 / 추천받은 회원 2건 체험) 등을 회사가 정하여 공지합니다.</li>
    <li>프로모션·무료로 제공된 금액·기간은 환불 대상이 아닙니다(환불정책 1.5).</li>
  </ul>
  <h3>8.3 변경</h3>
  <p>프로모션 내용은 회사의 사정에 따라 변경·종료될 수 있으나, 이미 적용된 혜택을 소급하여 불리하게 변경하지 않습니다.</p>
</section>

<div class="card">
  <h2 style="font-size:14px;font-weight:700;color:var(--sub);margin-bottom:10px">부록 — 관련 문서 및 관리</h2>
  <ul>
    <li>개인정보 처리방침은 별도 문서(<a href="/privacy">인디피아 개인정보 처리방침</a>)를 따릅니다.</li>
    <li>자재중계·시공중계·광고·포인트 등 부가서비스의 개별서비스 약관은 플랫폼 단계 진입 시 별도로 마련합니다(약관 제9조).</li>
    <li>각 정책은 서비스 내 '정책/약관' 메뉴에 게시하며, 버전과 시행일을 관리합니다.</li>
  </ul>
  <p style="margin-top:10px">본 통합본 시행일: 2026년 9월 1일</p>
</div>
`;
